'use client';

import Icon from '@/components/ui/AppIcon';

interface ComparisonFeature {
  category: string;
  features: {
    name: string;
    luxos: boolean | string;
    primera?: boolean | string;
    classica: boolean | string;
  }[];
}

interface ComparisonTableProps {
  comparisonData: ComparisonFeature[];
}

export default function ComparisonTable({ comparisonData }: ComparisonTableProps) {
  const renderValue = (value: boolean | string) => {
    if (typeof value === 'boolean') {
      return value ? (
        <Icon name="CheckCircleIcon" size={24} className="text-success mx-auto" variant="solid" />
      ) : (
        <Icon name="XCircleIcon" size={24} className="text-muted-foreground mx-auto" variant="solid" />
      );
    }
    return <span className="text-text-primary font-medium">{value}</span>;
  };

  return (
    <div className="bg-white rounded-2xl shadow-subtle border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead>
            <tr className="bg-gradient-to-r from-primary to-secondary text-white">
              <th className="px-6 py-4 text-left font-display text-lg">Features</th>
              <th className="px-6 py-4 text-center font-display text-lg">Luxos</th>
              <th className="px-6 py-4 text-center font-display text-lg">Primera</th>
              <th className="px-6 py-4 text-center font-display text-lg">Classica</th>
            </tr>
          </thead>
          <tbody>
            {comparisonData.map((category, categoryIndex) => (
              <>
                <tr key={`category-${categoryIndex}`} className="bg-muted">
                  <td colSpan={4} className="px-6 py-3 font-semibold text-primary">
                    {category.category}
                  </td>
                </tr>
                {category.features.map((feature, featureIndex) => (
                  <tr
                    key={`feature-${categoryIndex}-${featureIndex}`}
                    className="border-b border-border hover:bg-muted/50 transition-colors duration-200"
                  >
                    <td className="px-6 py-4 text-text-secondary">{feature.name}</td>
                    <td className="px-6 py-3 text-center">{renderValue(feature.luxos)}</td>
                    <td className="px-6 py-3 text-center">{renderValue(feature.primera ?? '-')}</td>
                    <td className="px-6 py-3 text-center">{renderValue(feature.classica)}</td>
                  </tr>
                ))}
              </>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
}